import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Swal from 'sweetalert2/dist/sweetalert2.all.js'
import withReactContent from 'sweetalert2-react-content'

const Signature = ({ setSignature }) => {
    const sigRef = useRef(null);
    const MySwal = withReactContent(Swal);

    const saveSignature = async () => {
        if (sigRef.current.isEmpty()) {
            alert("Please provide a signature first.");
            return;
        }
        const dataURL = sigRef.current.toDataURL('image/png');
        setSignature(dataURL);
        MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Signature saved successfully!',
        });
    };

    const clearSignature = () => {
        sigRef.current.clear();
        setSignature(null);
    };

    return (
        <div style={{ border: '1px solid black', paddingBlock: '10px' }}>
            <h3>Draw your signature</h3>
            <SignatureCanvas
                penColor="black"
                canvasProps={{ width: 100, height: 200, className: 'sigCanvas' }}
                ref={sigRef}
            />
            <br />
            <button type="button" onClick={clearSignature}>Clear</button>
            <button type="button" onClick={saveSignature}>Save</button>
        </div>
    );
};

export default Signature;
